import { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";
import { api } from "../api";
import { Alert, PageHeader } from "../components/Page";

export function Installations() {
  const [snippet, setSnippet] = useState<string>("");
  const [slug, setSlug] = useState<string>("");
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.getSnippet().then((r) => { setSnippet(r.snippet); setSlug(r.tenant_slug); })
      .catch((e) => setError(e.message));
  }, []);

  function copy() {
    navigator.clipboard.writeText(snippet);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <div>
      <PageHeader
        title="Helper Script"
        description="Paste this one line into your site template — it intercepts PDF clicks and opens the accessible Reader for visitors."
      />

      {error && <Alert>{error}</Alert>}

      <section className="card mb-6">
        <div className="card-header">
          <h2 className="text-base font-semibold text-slate-800">Your snippet</h2>
          <button onClick={copy} className="btn-secondary">{copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}{copied ? "Copied" : "Copy"}</button>
        </div>
        <pre className="card-body bg-slate-900 text-slate-100 text-sm overflow-x-auto rounded-b-lg font-mono">
{snippet || "(loading…)"}
        </pre>
      </section>

      <section className="card">
        <div className="card-body space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold text-slate-800">How to install</h2>
          <ol className="list-decimal list-inside space-y-1 text-slate-700">
            <li>Open your site's global template (header.html, footer.php, layout.tsx — whichever loads on every page).</li>
            <li>Paste the snippet just before the closing <code className="px-1 bg-slate-100 rounded">&lt;/body&gt;</code> tag.</li>
            <li>Save and deploy. Within 24 hours every PDF link gets an <span className="pill bg-brand-500 text-white">Accessible</span> badge.</li>
            <li>Go to the Sites tab and click <strong>Verify</strong>. We confirm the script loads, then crawl.</li>
          </ol>
          <p className="text-xs text-slate-500">Tenant slug: <code className="font-mono">{slug}</code></p>
        </div>
      </section>
    </div>
  );
}
